import { Injectable } from '@angular/core';
import { WindowService } from './window.service';
import { AnswerLockModel } from '../models/answer-lock.model';
import { ANSWERS_LOCKED } from '../constants/document.constants';
import { AppInsightsService } from './app-insights.service';

@Injectable()
export class AnswerLockService {
  private sessionId: string;
  private defaultAnswerLock: AnswerLockModel;

  constructor(private windowService: WindowService, private logger: AppInsightsService) {
    this.sessionId = windowService.getSessionIdFromWindow();
    this.defaultAnswerLock = {
      sessionId: '',
      timestamp: Date.now(),
    };
  }

  public getAnswerLock(casID: string | undefined): AnswerLockModel | null {
    const answersLockedString = localStorage.getItem(`${ANSWERS_LOCKED}_${casID}`);
    let answersLock: AnswerLockModel = this.defaultAnswerLock;

    if (answersLockedString) {
      answersLock = { answersLock, ...JSON.parse(answersLockedString) };

      if (answersLock.sessionId != null && answersLock.sessionId !== '' && answersLock.timestamp != null) {
        const currentTimestamp = Date.now();
        const differenceInSeconds = (currentTimestamp - (answersLock.timestamp ?? 0)) / 1000;
        if (differenceInSeconds >= 10) {
          console.error('WTF');
          // something failed, remove lock and log to app insights
          this.logger.logException({
            name: 'AnswerLockError',
            message:
              'An error has occured and there has been an answer lock for 10 seconds or longer. ' +
              JSON.stringify(answersLock),
          });
          this.forceRemoveAnswerLock(casID);
        } else {
          return answersLock;
        }
      }
    }

    return null;
  }

  public createAnswerLock(casID: string | undefined) {
    const answerLock: AnswerLockModel = {
      sessionId: this.windowService.getSessionIdFromWindow() ?? '',
      timestamp: Date.now(),
    };
    localStorage.setItem(`${ANSWERS_LOCKED}_${casID}`, JSON.stringify(answerLock));
  }

  public removeAnswerLock(casID: string | undefined) {
    const answersLocked = this.getAnswerLock(casID);
    // remove the lock only if the session id is the same as the current session
    if (answersLocked && answersLocked.sessionId !== this.windowService.getSessionIdFromWindow()) {
      return;
    }
    this.forceRemoveAnswerLock(casID);
  }

  public forceRemoveAnswerLock(casID: string | undefined) {
    const currentTimestamp = Date.now();
    console.debug('REMOVED ANSWER POOL', currentTimestamp, casID);
    localStorage.removeItem(`${ANSWERS_LOCKED}_${casID}`);
  }
}
